import create from 'zustand';
import { mountStoreDevtool } from 'simple-zustand-devtools';
import dayjs from 'dayjs';
import { processDate,parseTimestamp } from '../helpers/helpers';
import { ColumnsSocialEvents,ColumnsSideEvents} from '../helpers/ColumnsSocialEvents';
import { ColumnsDailySchedule} from '../helpers/ColumnsDailySchedule';
import CustomParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(CustomParseFormat);


const useStore = create((set, get) => ({
  // STATE VALUES
  // Define state values and defaults
  view: 'card',
  datasetType: 'new',
  loading: true,
  ajaxUrl:'',
  isFiltering:false,
  columnsGrid:'',
  gridOptions: { listType: 'fulllist', rowHeight: 50 },
  filters: { search: '', DateSession: '', TimeSession: '', Venue: '', Message: '', MeetingType: '', MeetingGroup:'', },
  sessions: [{}],
  pastSessions: [{}],
  newSessions: [{}],
  dateSessions:[],
  timeSessions:[],
  messages:[],  //invitation to
  slots: [],
  venues: [],
  meetingtypes: [],
  meetinggroups: [], //committee
  order: [{}],
  loaded_slots: [{}],
  settings: {
    //ajaxurl: 'https://pp22.itu.int/pp22event-sessions.json',
    is_multisite: false,
    current_blog: 1,
    localize_index: 0,
    params: {
      listtype: 'fulllist',
      displayviewswitch: true,
      viewtype: '',
      datasource: 'social_events', // values: social_events or daily_schedule or side_events
    },
  },
  MUIdata: { rows: [], columns: [] },

  // METHODS
  // State methods
  // Toggle loading state
  //toggleLoading: () => {
   // set((state) => ({ ...state, loading: !state.loading }));
 // },

  // Set a filter value
  setFilter: (key, value) => {
    set((state) => ({ ...state, filters: { ...state.filters, [key]: value } }));
    get().buildMUIData();
  },

  setFiltering:()=>{

    const filtersObject=get().filters;

    if(filtersObject.search!== ''|| filtersObject.DateSession!==  ''|| filtersObject.TimeSession!== ''|| filtersObject.Venue!== ''|| filtersObject.Message!== ''|| filtersObject.MeetingType!== ''||  filtersObject.MeetingGroup!=='' )
    set((state) => ({ ...state, isFiltering: true }));

  },

  // Set the ajax url value depending on data source
  changeAjaxUrl: (datasource) => {

    switch (datasource) {

      case 'social_events':
         //social events url
        set((state) => ({ ...state, ajaxUrl: 'https://pp22.itu.int/pp22event-sessions.json' }));
        break;

      case 'side_events':
          //side events url
        set((state) => ({ ...state, ajaxUrl: 'https://pp22.itu.int/pp22event-sessions-side.json' }));
        break;

      default:
        //daily schedule url
        set((state) => ({ ...state, ajaxUrl: 'https://pp22.itu.int/pp22event-sessions-all.json' }));
    }
    
  },

  // Set the view value
  changeView: (viewname) => {
    set((state) => ({ ...state, view: viewname }));
  },

// Set the grid columns value
changeColumnsGrid: (datasource) => {
   
    switch (datasource) {

      case 'social_events':
         //social events columns
         set((state) => ({ ...state, columnsGrid:ColumnsSocialEvents}));
        break;

      case 'side_events':
          //side events columns
          set((state) => ({ ...state, columnsGrid:ColumnsSideEvents}));
        break;

      default:
        //daily schedule columns
        set((state) => ({ ...state, columnsGrid: ColumnsDailySchedule }));
    }

    },

  // change dataset to old or new sessions data
  changeDataSet: () => {

     // Define empty data grid
     let dataGrid = { rows: [], columns: [] };

     // GET datagrid columns state depending on the datasource. see function changeColumnsGrid
     dataGrid.columns = get().columnsGrid;
    
      // Save the datagrid to the store
     set((state) => ({ ...state, MUIdata: dataGrid }));

    if(get().datasetType==='new')
    {
      
      //load past sessions   
    set((state) => ({ ...state, sessions: state.pastSessions }));
   
    //change datasettype
    set((state) => ({ ...state, datasetType: 'past' }));
    }
    else
    {
    //set((state) => ({state, sessions: [] }));
    set((state) => ({ ...state, sessions: state.newSessions }));
    set((state) => ({ ...state, datasetType: 'new' }));
    }

    get().buildMUIData()
  },

 


  // Update the settings if in a wp-environment from the localize script data
  updateSettings: () => {

    //get the wpsettings from gutenberg\render_callbacks\render_social_events.php
    let wpSettings = window.itu_social_events;
    //console.log(window.itu_social_events)

    if (wpSettings === null || wpSettings === undefined) { 

      wpSettings=get().settings //load local settings if no wordpress settings
    }

    
    if (wpSettings) {

      //set ajax url to social_events or daily schedule or side_events
      //get().changeAjaxUrl(wpSettings.params.datasource)

      if(wpSettings.params.datasource!== undefined && wpSettings.params.datasource!== '')
      {
        get().changeAjaxUrl(wpSettings.params.datasource)

        //set columns grid
        get().changeColumnsGrid(wpSettings.params.datasource)
      }
      else{
        //display default social events in case there is no defined data source
        get().changeAjaxUrl(get().settings.params.datasource)
        get().changeColumnsGrid(get().settings.params.datasource)

      }

      //load the settings state
      set((state) => ({ ...state, settings: wpSettings }));


      //get().changeListType(wpSettings.params.listtype);
      //console.log(wpSettings)

      //activate viewtype selection from wordpress
      /*if(wpSettings.params.viewtype!== undefined && wpSettings.params.viewtype!== '')
      {
      get().changeView(wpSettings.params.viewtype);
      }*/
     
    } 
    else
     {
      console.log('No wp settings found');
    }
  },

  // Get the sessions data from the REST API
  updateData: async () => {
    // Set REST API endpoints
    
    const sessionsEndpoint =get().ajaxUrl //get the ajax url state

    //console.log(sessionsEndpoint)
   

    // Set sessions and session related store parts
    await fetch(sessionsEndpoint)
      .then((res) => res.json())
      .then((jsondata) => {
        //console.log(jsondata.d.results);
        const data=jsondata.d.results;
      
     
        /*****fill-in the dateSessions, venues, messages (inviation to), meetingtypes, meetinggroups(committee)
         *  and build past and upcoming sessions array state************/
        let messages = [];
        let meetingtypes = [];
        let meetinggroups = [];
        let venues = [];
        let timeSessions = [];
        let dateSessions = [];
        let pastSessions= [];
        let newSessions= [];
        const dateToday = dayjs(new Date()).format('DD/MM/YYYY') // "28/09/2022"// 

       
        data.forEach((session) => {
          if(session.From !== undefined)
          {

            /**set monitortitle to description if empty */
            if (session.MonitorTitle==="")       
            session.MonitorTitle=session.Description

            
             /****set agenda doc to dms url if available */   
             if (session.DocumentNumber)       
             session.DocumentNumber='https://www.itu.int/md/'+session.DocumentNumber

            /**remove two hours from session.from to match roumania time zone */
            
            /****start time *******/
            /*********************** */
            //console.log(session.From.indexOf("("))
            let firstindex=String(session.From).indexOf("(")
            let lastindex=String(session.From).lastIndexOf(")")

            const unixTimeStamp=parseInt( String(session.From).substring(
              firstindex + 1,  lastindex
               ))

            const dateTimeZone = new Date(parseTimestamp(unixTimeStamp));
            //dateTimeZone.setHours(dateTimeZone.getHours() - 2);//remove 2 hours
            //console.log(dateTimeZone)

            /****set new start time */          
            session.From=dateTimeZone; 

            /**============== */

             /****end time *******/
            /*********************** */
            let firstindexTo=String(session.To).indexOf("(")
            let lastindexTo=String(session.To).lastIndexOf(")")

            const unixTimeStampTo=parseInt( String(session.To).substring(
              firstindexTo + 1,  lastindexTo
               ))

            const dateTimeZoneTo = new Date(parseTimestamp(unixTimeStampTo));
            //dateTimeZone.setHours(dateTimeZone.getHours() - 2);//remove 2 hours
            //console.log(dateTimeZone)

            /****set new end time */          
            session.To=dateTimeZoneTo; 
          
            
             /*****fill-in the meetingtypes to array state*/
             if (
              !meetingtypes.includes(session.MeetingType) &&
              session.MeetingType
            ) {
              meetingtypes.push(session.MeetingType);
            }

            /*****fill-in the meetinggroups:committee to array state*/
             if (
              !meetinggroups.includes(session.MeetingGroup) &&
              session.MeetingGroup
            ) {
              meetinggroups.push(session.MeetingGroup);
            }


           /*****fill-in the messages:invitation to array state*/
            if (
              !messages.includes(session.Message) &&
              session.Message
            ) {
              messages.push(session.Message);
            }

          
          /*****fill-in the venues array state*/
            if (
              !venues.includes(session.RoomName) &&
              session.RoomName
            ) {


              venues.push(session.RoomName);
            }

      

          /*****fill-in the timeSessions array state*/
            const timeSession= dayjs(dateTimeZone).format('HH:mm')   
   
             if (
               !timeSessions.includes(timeSession) &&
               timeSession
             ) 
             {
               timeSessions.push(timeSession);
             }
      
    
        /*****fill-in the dateSessions array state*/
          const dateSession= dayjs(dateTimeZone).format('DD/MM/YYYY')

          //console.log(processDate(dateSession))

          if (
            !dateSessions.includes(dateSession) &&
            dateSession
          ) {
            dateSessions.push(dateSession);
          }

        /**fill in past sessions and new sessions array */
        
          //console.log(processDate(dateSession))
          
          if(processDate(dateSession)>=processDate(dateToday)){
            newSessions.push(session)
          }
          else{
            pastSessions.push(session)
          }


        }
        });

        /**sort meetingtypes array and set state */
        meetingtypes.sort();        
        set((state) => ({ ...state, meetingtypes:meetingtypes}));

        /**sort meetinggroups(committee) array and set state */
        meetinggroups.sort();        
        set((state) => ({ ...state, meetinggroups:meetinggroups}));

        /**sort messages(inviation to) array and set state */
        messages.sort();
        //console.log(messages)
        set((state) => ({ ...state, messages:messages}));

        /**sort venues array and set state */
        venues.sort();
        //console.log(venues)
        set((state) => ({ ...state, venues:venues}));

        /**sort timeSessions array and set state */
         // console.log(timeSessions)
        timeSessions.sort() 
          // and set state
         set((state) => ({ ...state, timeSessions:timeSessions}));
           
        /**sort dateSessions array and set state */
        //console.log(dateSessions)       
        dateSessions.sort(function(a,b) {
          a = a.split('/').reverse().join('');
          b = b.split('/').reverse().join('');
          //return a > b ? 1 : a < b ? -1 : 0;
           return a.localeCompare(b);         // <-- alternative 
        });
        set((state) => ({ ...state, dateSessions:dateSessions}));

        
       /**sort new and past sessions array by date and set state */
        //sort data by date from asc
        
        pastSessions.sort(function (a, b) {

          const dateA=parseInt(a.From.getTime())

          const dateB=parseInt(b.From.getTime())

          return dateA-dateB;
          })
        
        newSessions.sort(function (a, b) {

          const dateA=parseInt(a.From.getTime())

          const dateB=parseInt(b.From.getTime())

          return dateA-dateB;
          })


       

       
        set((state) => ({ ...state, sessions: newSessions }));
       
        set((state) => ({ ...state, pastSessions: pastSessions }));
        set((state) => ({ ...state, newSessions: newSessions }));
      });

    
    // Rebuild the MUI datatable data
    get().buildMUIData();
    // Toggle loading state
    //set((state) => ({ ...state, loading: false }));
  },

  // Build the MUI datatable data
  buildMUIData: async () => {
    // Set loading to true
    //get().toggleLoading();

    // Define empty data grid
    let dataGrid = { rows: [], columns: [] };

    // get datagrid columns depending on the datasource. see function changeColumnsGrid
    dataGrid.columns = get().columnsGrid

    //check if filters are activated and set filtering state
    get().setFiltering()
    let isFiltering=get().isFiltering
    //console.log('filters activated'+isFiltering)
    
    // Loop through the sessions order
     const sessions = get().sessions;
     const datasource=get().settings.params.datasource;

     sessions.length > 0 &&
     sessions.forEach((session) => {
       
     
        //build event calendar item
      
         const startDay=dayjs(session.From).format('DD/MM/YYYY')
         const startTime=dayjs(session.From).format('HH:mm')         
       
         const endDay=dayjs(dayjs(session.To)).format('DD/MM/YYYY')
         const endTime=dayjs(dayjs(session.To)).format('HH:mm')         

          //Only for social events. Meetings Internal or external to the palace 
         if (session.Building && !isFiltering && (datasource==='social_events' || datasource==='side_events')) {

          session.RoomName = session.Building==='P' ? session.RoomName + " (Internal)" : session.RoomName + " (External)";
          }

              // Define a new row with columns common to all list types
              let newRow = {
                id: session.ReservationId,
                'MeetingType':session.MeetingType,
                'MonitorTitle':session.MonitorTitle,
                'DateSession':startDay,
                'TimeSession':startTime,
                'EndDaySession':endDay,
                'EndTimeSession':endTime,
                'TimeSessionStartEnd':startTime+ ' - ' +endTime,
                'RoomName':session.RoomName,
                'Message':session.Message,  //invitation to
                'MeetingGroup':session.MeetingGroup, //commitee
                'DocumentNumber':session.DocumentNumber, //agenda
                'Comments':session.Comments, 
                'CalendarDate':'Add to calendar',
              };

              //console.log(newRow.MonitorTitle)

              // Push new row to datagrid rows array
              dataGrid.rows.push(newRow);
            

          // APPLY FILTERS
          // If date filter
          if (get().filters.DateSession && get().filters.DateSession.length > 0) {
            dataGrid.rows = dataGrid.rows.filter(
              (row) => row.DateSession === get().filters.DateSession
            );
          }
          // If time filter
          if (get().filters.TimeSession.length > 0) {
            dataGrid.rows = dataGrid.rows.filter(
              (row) => row.TimeSession === get().filters.TimeSession
            );
          }

           // If Venue filter
           //console.log(get().filters.Venue)
           if (get().filters.Venue.length > 0) {
           
            dataGrid.rows = dataGrid.rows.filter(             
              (row) =>{ 
                const RoomName=row.RoomName
                const Venue=get().filters.Venue
                //const includes=RoomName.includes(Venue)
                //console.log(RoomName + ' includes ' + Venue + ':'+ includes)
                return RoomName.includes(Venue)
              }
            );
          }


           // If MeetingType filter
           //console.log(get().filters.MeetingType)
           if (get().filters.MeetingType.length > 0) {
            dataGrid.rows = dataGrid.rows.filter(
              (row) => row.MeetingType === get().filters.MeetingType
            );
          }

           // If MeetingGroup: COMMITTEE filter
           //console.log(get().filters.MeetingGroup)
           if (get().filters.MeetingGroup.length > 0) {
            dataGrid.rows = dataGrid.rows.filter(
              (row) => row.MeetingGroup === get().filters.MeetingGroup
            );
          }

            // If Message:Invitation to filter
           //console.log(get().filters.Venue)
           if (get().filters.Message.length > 0) {
            dataGrid.rows = dataGrid.rows.filter(
              (row) => row.Message === get().filters.Message
            );
          }
       
          // If search filter
          if (get().filters.search.length > 0) {
            dataGrid.rows = dataGrid.rows.filter(
              (row) =>
                row.MeetingType
                  .toLowerCase()
                  .includes(get().filters.search.toLowerCase()) ||
                row.MonitorTitle
                  .toLowerCase()
                  .includes(get().filters.search.toLowerCase()) ||
                row.DateSession
                  ?.toLowerCase()
                  .includes(get().filters.search.toLowerCase()) ||
                row.TimeSession
                  ?.toLowerCase()
                  .includes(get().filters.search.toLowerCase()) ||
                row.RoomName
                  ?.toLowerCase()
                  .includes(get().filters.search.toLowerCase())||
                row.Message
                    ?.toLowerCase()
                    .includes(get().filters.search.toLowerCase())
            );
          }
          // Save the datagrid to the store
          set((state) => ({ ...state, MUIdata: dataGrid }));
          // Set loading to false
          //get().toggleLoading();
        
      });
  },

 
}));




// If dev env add devtools
if (process.env.NODE_ENV === 'development') {
  mountStoreDevtool('Zustand store', useStore);
}
export default useStore;
